import styled from 'styled-components';


import BGBanner from '../../../assests/images/bg-banner.webp';

export const DonateToUsBanner = styled.section`
    background-image:url(${BGBanner});
    background-color:#ddf5f6;
    padding:60px 0;

    @media screen and (max-width: 1024px){
        padding: 180px 0px 50px;
    }
`;

export const DonateToUsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 767px){
        flex-direction: column;
        row-gap: 20px;
    }

`;
export const DonateToUsText = styled.div`
   width:100%;
   max-width:509px;

   button{
    padding: 12px 67px;

    @media screen and (max-width: 480px){
        padding: 12px 20px;
    }
   }
`;
export const DonateToUsImage = styled.div`
    width:100%;
    max-width:575px;
    position: relative;

    @media screen and (max-width: 480px){
        max-width: 100%;
    }
`;
export const Title = styled.h1`
    color:#01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: 600;
    line-height: 60px;
    margin-bottom: 12px;

    @media screen and (max-width: 991px){
        font-size: 38px;
        line-height: 50px;
    }

    @media screen and (max-width: 767px){
        font-size: 34px;
        line-height: 46px;
    }

    @media screen and (max-width: 575px){
        font-size: 30px;
        line-height: 42px;
    }
`;

export const DonateToUsContent = styled.p`
    color:#333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 21px;
    margin-bottom: 30px;
`;
export const MainImage = styled.div`
    text-align: right;
    img{
        width:100%;
        max-width: 457px;
    
        @media screen and (max-width: 480px){
            max-width: inherit 
        }
    }
`;

export const TopImage = styled.div`
    position: absolute;
    left: 0px;
    
    @media screen and (max-width: 480px){
        position: relative;
        width: 100%;
        margin-bottom: 20px;
    }

    img{
        width: 100%;
        max-width: 179px;

        @media screen and (max-width: 480px){
            max-width: inherit 
        }
    }
`;

export const BottomImage = styled.div`
    position: absolute;
    left: 35px;
    bottom: 0;

    @media screen and (max-width: 480px){
        position: relative;
        width: 100%;
        left: inherit;
        margin-top: 20px
    }

    img{
        width: 100%;
        max-width: 282px;
        
        @media screen and (max-width: 480px){
            max-width: inherit 
        }
    }
`;

export const ImpactNumbers = styled.section`
    background: #F1FEFF 0% 0% no-repeat padding-box;
    padding:50px 0;

    @media screen and (max-width: 575px){
        padding:40px 0;
    }
`;

export const OurImpactNumbers = styled.div`
    width:100%;
    max-width:1088px;
    margin: 0 auto;
   padding-bottom:50px;
`;

export const OurImpactTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 20px;
    text-transform: uppercase;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
        margin-bottom: 0px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const OurNumber = styled.div`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 35px;
    width:170px;
    min-width:170px;
    height:150px;
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: 700;
    line-height: 75px;
    margin-bottom:0px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 767px){
        margin-top: 20px;
    }

    @media screen and (max-width: 575px){
        width: 100%;
        min-width: 100%;
        height: 70px;
        border-radius: 15px;
        font-size: 30px;
        line-height: 55px;
        
    }

    &:last-child{
        @media screen and (max-width: 767px){
            margin-top: 0px;
        }
    }
`;

export const NumberTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom:0px;
    width:170px;
    max-width:170px;
    text-align: center;
    margin-top: 20px;
    @media screen and (max-width: 575px){
        font-size:18px;
        line-height: 26px;
        margin: 10px auto 0;
    }
`;

export const SupportMission = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:50px;
    margin-bottom:60px;
    gap:40px;

    @media screen and (max-width: 991px){
        padding: 20px;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 50px;
        gap: 20px;
        flex-direction: column;
    }
    @media screen and (max-width: 575px){
        margin-top:40px;
        margin-bottom: 40px;
    }
`;

export const SupportMissionContent = styled.div`
    width:100%;
    max-width:522px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }

    button {
        padding: 12px 67px;
        
        @media screen and (max-width: 480px){
            padding: 12px 20px;
        }
    }
`;

export const SupportMissionText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight:400;
    line-height: 27px;
    margin-bottom:30px;
`;

export const SupportImage = styled.div`
    img{
       width:100%;
    }
`;

export const ClientQuotesContent = styled.div`
    background: #EFEFEF 0% 0% no-repeat padding-box;
    border-radius: 20px;
    width:100%;
    max-width:522px;
    padding:35px 20px 20px 20px;
    position: relative;

    @media screen and (max-width: 991px){
        max-width: 100%;
        margin-top: 40px;
    }
`;

export const QuotesIcon = styled.div`
    position: absolute;
    top: -26px;
`;

export const ClientText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 10px;
`;

export const ClientName = styled.span`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 700;
    line-height: 21px;
`;

export const TaxDeductible = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #000000;
    border-radius: 15px;
    padding:30px;

    @media screen and (max-width: 575px){
        padding: 20px;
    }
`;

export const TaxDeductibleImage = styled.div`
   width:100%;
   max-width:263px;

   
    @media screen and (max-width: 757px){
        margin: 20px 0px 0px; 
    }

   img{
    width:100%;
   }
`;

export const TaxDeductibleText = styled.div`
    display: flex;
    gap:30px;

    @media screen and (max-width: 575px){
        flex-direction: column;
        gap:20px;
    }
`;


export const TaxDeductibleContent = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom:20px;
    
    a{
        text-decoration:none;
    }
    @media screen and (max-width: 575px){
        font-size:16px;
        line-height: 24px;
    }
        strong{
            color:#01606F;
            font-weight: 700;
            cursor:pointer;
        }
      &:last-child{
        margin-bottom:0px;
      }  
`;
export const DeductibleText = styled.div`
`;
